export const environment = {
  name: 'uat',
  production: false,
  appUrl: 'https://app-lockton-latam-uat.azurewebsites.net',
  apiUrl:
    'https://api-lockton-latam-uat-avbmejc5end7d9av.brazilsouth-01.azurewebsites.net/v1',
  apiUrlV2:
    'https://api-lockton-latam-uat-avbmejc5end7d9av.brazilsouth-01.azurewebsites.net/v2',
  mediaUrl: 'https://storagelocktonlatamuat.blob.core.windows.net',
  storageAccountName: 'storagelocktonlatamuat',
  appInsights: {
    disableTelemetry: false,
    connectionString:
      'InstrumentationKey=532dc3ff-5cc2-4782-9ad9-45125cda63ef;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/',
  },
  loqateConfig: {
    serviceKey: 'UG22-RM53-UZ45-AP71',
    findUrl: 'https://api.addressy.com/Capture/Interactive/Find/v1.1',
    retrieveUrl: 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2',
  },
  remotes: {
    lsos: 'https://app-lockton-lsos-uat.azurewebsites.net/',
  },
  stripeKey:
    'pk_test_51PXh3zGWdFA1eY5W04V2H1oI0U483gVFS6P5JfuJeAVeQIUV2sAwNqj21SM5Dxzb1KTfC6bIZWBOCKJ2Av8J6xK000oOdT69gQ',
  oneTrustConfig: {
    disabled: false,
    domainScript: '01912c06-f5c7-77f4-80f6-9dff15f25cd3-test',
  },
  tinymceKey: 'vv2z27xk664cnfsicvdmx8hfwexz5xx737tbuog4j8p378oi',
  features: {
    contentful: true,
    portalConfig: true,
    proposalDocuments: true,
    newClientEnquiriesForExistingClients: true,
    allowExperimental: true,
    experimentalByDefault: true,
  },
  googleTagManagerId: 'GTM-NBHC79VG',
  freshdeskConfig: {
    disabled: false,
    widgetId: '103000007813',
    environment: 'UAT',
  },
  useMocksFor: ['3-2'],
};
